let co2e = "<span><math display='inline'><mi>CO</mi><sub>2</sub><mi>e</mi></math></span>";
let thead = {
  detect: ["日期", "鉛", "鎘", "汞", "鉻", "砷", "六價鉻", "抗壓強度", "戴奧辛", "銅", "硒", "鋇"],
  service: [
    ["核准年度", "一般廢棄物", "一般事業廢棄物", "焚化處理量", "底渣量"],
    ["飛灰固化物量", "廢氣處理設備活性碳使用量", "實際發電量", "實際售電量", "實際售電率"],
    ["售電收入", "操作時數", "停爐時數", "設計處理量", "灰渣送至掩埋場掩埋量"],
  ],
};
let data = {
  Air: [
    {
      date: "2021 年第 2 季",
      component: "0.2840",
      pollutant: "0",
      oxysulfide: "0",
      oxynitride: "0",
      status: "完成核算",
    },
  ],
  Water: [],
  Waste: [
    {
      date: "2021 年 10 月",
      waste_title: "D-0299 廢塑膠混合物",
      cleaning_method: "將廢棄物作為再利用之原料使用",
      output_amount: "15.9070",
      status: "-",
    },
    {
      date: "2021 年 10 月",
      waste_title: "D-0299 廢塑膠混合物",
      cleaning_method: "焚化處理",
      output_amount: "4.4100",
      status: "-",
    },
  ],
  Toxic: [],
  Metal: [
    {
      date: "2020/11/04",
      id: "P002",
      pollutant: "戴奧辛",
      result: "0.0140",
      unit: "ng-TEQ/Nm3",
      status: "定檢合格",
    },
  ],
  Penalty: [],
  bottom_detect: [],
  ash_detect: [],
  air_detect: [],
  annual_service: [],
  montly_service: [],
};

let table_data = {
  latest_declare: {
    Air: {
      id: "Air",
      title: "空氣污染",
      unit: true,
      category: [
        { name: "Period", title: "申報時段" },
        { name: "EmiItem1", title: "揮發性有機化合物" },
        { name: "EmiItem2", title: "粒狀污染物" },
        { name: "EmiItem3", title: "硫氧化物 " },
        { name: "EmiItem4", title: "氮氧化物 " },
        { name: "PerStatus", title: "申報狀態 " },
      ],
      noResult: {
        status: true,
        title: "屬空污列管的對象為何無排放量申報資料?",
        content: "屬空污列管的對象且須符合本部第一批及第二批公私場所應申報年排放量之固定污染源者，才需申報空污排放量，因此未符合公告條件對象者，可能無排放量申報資料。",
      },
      other_data: [
        {
          title: "資料來源",
          content: "大氣環境司 (固定污染源空污費暨排放量申報整合管理系統)",
        },
        {
          title: "更新頻率",
          content: "六個月",
        },
      ],
    },
    Water: {
      id: "Water",
      title: "水污染",
      unit: false,
      category: [
        { name: "Period", title: "申報時段", width: "10%" },
        { name: "DischargeNo", title: "放流口" },
        { name: "EmiItemName", title: "檢測項目" },
        { name: "EmiItemValue", title: "檢測數值" },
        { name: "EmiItemUnit", title: "檢測單位 " },
      ],
      noResult: {
        status: false,
      },
      other_data: [
        {
          title: "資料來源",
          content: "水質保護司 (水污染源管制資料管理系統)",
        },
        {
          title: "資料申報及更新頻率",
          content: "依水污染防治法規定，事業或污水下水道系統申報頻率為每半年一次，直轄市及縣（市）政府環境保護局受理後，尚須審查後始載入系統登錄，原則每月更新已載入之資料供查詢。",
        },
        {
          title: "資料說明",
          content_list: [
            "申報資料空白者：係為直轄市、縣（市）環境保護局審核中。",
            "本系統排放資料係指取得排放許可證者，其廢水排放至地面水體之排放資訊。",
            "如水污染防治許可種類屬貯留、回收、委託、土壤處理、水措計畫者，因無排放廢水至地面水體行為無排放資訊。",
            "重金屬申報資料為事業單位依行業別及製程特性申報，非所有業別共通之應檢測水質項目。",
          ],
        },
      ],
    },
    Waste: {
      id: "Waste",
      title: "廢棄物 (含再利用)",
      unit: true,
      category: [
        { name: "Period", title: "申報時段" },
        { name: "EmiItemName", title: "廢棄物名稱" },
        { name: "CleanName", title: "廢棄物清理方式" },
        { name: "EmiItemValue", title: "產出申報量" },
        { name: "EmiStatus", title: "申報狀態 " },
      ],
      noResult: {
        status: false,
      },
      other_data: [
        {
          title: "資料來源",
          content: "資源循環署 (事業廢棄物申報及管理系統) - 客服專線：0800-059777",
        },
        {
          title: "資料申報",
          content: "依廢清法第三十一條規定，事業廢棄物之產出情形申報頻率為每月一次",
        },
        {
          title: "更新頻率",
          content: "三個月 (於每年 2、5、8、11 月底更新資料)",
        },
        {
          title: "資料說明",
          content: "以本年 2 月為例，提供資料為去年 10-12 月之申報資料；5 月底提供 1-3 月之申報資料；8 月底提供 4-6 月之申報資料；11 月底提供 7-9 月之申報資料。",
        },
      ],
    },
    Toxic: {
      id: "Toxic",
      title: "毒性化學物質",
      unit: true,
      category: [
        { name: "Period", title: "申報時段" },
        { name: "EmiItemId", title: "毒化物列管編號" },
        { name: "ToxicName", title: "毒化物中文名稱" },
        { name: "ToxicEngName", title: "毒化物英文名稱" },
        { name: "EmiValue", title: "申報量 " },
      ],
      noResult: {
        status: true,
        title: "民眾反映毒化物列管廠家排放資料開放太少問題",
        content: "毒化物列管廠家排放資料開放製造、輸入許可證每月運作量查詢，因製造、輸入係屬源頭運作量，可作為統計國內年運作總量，瞭解國內運作情形。至於使用量或貯存量，是屬於短暫過渡數量，且易與製造、輸入量重複計算，故不列入。",
      },
      other_data: [
        {
          title: "備註",
          content: "依檢核進度公開2022年釋放量資料，至2023年釋放資料，正檢核中。",
        },
        {
          title: "資料來源",
          content: "化學物質管理署 (毒性化學物質登記申報系統) - 客服專線：週一～週五 （02）2370-1999；假日 0972-700597",
        },

        {
          title: "更新頻率",
          content: "三個月",
        },
        {
          title: "資料說明",
          content: "本資料為廠商申請毒性化學物質製造、輸入及使用之運作量。",
        },
      ],
    },

    Toxic_Release: {
      id: "Toxic_Release",
      title: "",
      unit: true,
      category: [
        { name: "Year", title: "申報時段" },
        { name: "EmiItemId", title: "毒化物列管編號" },
        { name: "ToxicName", title: "毒化物中文名稱" },
        { name: "ToxicEngName", title: "毒化物英文名稱" },
        { name: "ReleaseQty", title: "釋放量 " },
      ],
      // noResult: {
      //   status: true,
      //   title: "民眾反映毒化物列管廠家排放資料開放太少問題",
      //   content: "毒化物列管廠家排放資料開放製造、輸入許可證每月運作量查詢，因製造、輸入係屬源頭運作量，可作為統計國內年運作總量，瞭解國內運作情形。至於使用量或貯存量，是屬於短暫過渡數量，且易與製造、輸入量重複計算，故不列入。",
      // },
      // other_data: [
      //   {
      //     title: "備註",
      //     content: "依檢核進度公開2020年釋放量資料，至2021年釋放資料，正檢核中。",
      //   },
      //   {
      //     title: "資料來源",
      //     content: "化學物質管理署 (毒性化學物質登記申報系統) - 客服專線：週一～週五 （02）2370-1999；假日 0972-700597",
      //   },

      //   {
      //     title: "更新頻率",
      //     content: "三個月",
      //   },
      //   {
      //     title: "資料說明",
      //     content: "本資料為申請毒性化學物質製造許可 / 核可證、輸入許可 / 核可證廠商之月運作量。",
      //   },
      // ],
    },
    Metal: {
      id: "Metal",
      title: "有害空氣污染",
      unit: false,
      category: [
        { name: "ExamDate", title: "檢測日期" },
        { name: "EmiChimney", title: "煙道編號" },
        { name: "ExamItemName", title: "污染物" },
        { name: "ExamItemValue", title: "檢測結果" },
        { name: "ExamItemUnit", title: "檢測度量單位" },
        { name: "ExamStatus", title: "審查狀態 / 稽查結果" },
      ],
      noResult: {
        status: false,
      },
      other_data: [
        {
          title: "備註",
          content: "檢測結果欄位空白，表示該次檢測經地方主管機關確認，毋須進行該項有害空氣污染物檢測。",
        },
        {
          title: "資料來源",
          content: "大氣環境司（固定污染源空污費暨排放量申報整合管理系統）",
        },

        {
          title: "更新頻率",
          content: "三個月",
        },
        {
          title: "資料說明",
          content:
            "多環芳香烴碳氫化合物（以下簡稱 PAHs）目前國外均尚未訂定排放標準管制限值，尚無法將其列為工廠之公開排放資料。其次，砷及其他有害空氣污染物之排放資料，本部將納入後續研議增列公告應定期檢測及申報排放量。針對有害空氣污染物相關之「調查研究委辦計畫」之成果報告，可由本部「<a href='#'>環保專案登錄系統</a>」查閱下載倘對有害空氣污染物排放資料內容有疑義，可洽本部大氣環境司（電話：(02) 23712121 分機 6207，或利用本系統「<a href='https://epamail.moenv.gov.tw/front/mailboxhome' title='另開新視窗，至「首長信箱」' target='_blank'>意見信箱</a>」與本部確認）。",
          content_list: ["本部指定公告應實施定期檢測之廢棄物焚化處理程序之定期檢測申報有害空氣污染物「鉛」、「鎘」、「汞」及「酸性氣體 (氯化氫)」之排放濃度檢測結果；", "全國「戴奧辛」列管污染源之戴奧辛排放濃度檢測結果。"],
          // links:[
          //     {title: "環保專案登錄系統", href:"https://epamail.moenv.gov.tw/front/mailboxhome"},
          //     {title: "意見信箱", href:"https://epamail.moenv.gov.tw/front/mailboxhome"},
          // ]
        },
      ],
    },
    Penalty: {
      id: "Penalty",
      title: "裁處資訊",
      unit: false,
      category: [
        { name: "PENALTYDATE", title: "裁處時間" },
        { name: "COUNTY", title: "裁處機關" },
        { name: "DOCUMENTNO", title: "裁處書字號" },
        { name: "TRANSGRESSDATE", title: "違反日期" },
        { name: "TRANSGRESSLAW", title: "違反法令 " },
        { name: "PENALTYMONEY", title: "裁處金額" },
        { name: "ISIMPROVE", title: "改善狀況" },
        { name: "detail", title: "詳細" },
        // {name: "sub_info",title: "子案"}
      ],
      noResult: {
        status: false,
      },
      other_data: [
        {
          title: "備註",
          content: "罰鍰總金額僅計算含有實際罰鍰之裁處案件。",
        },
        {
          title: "資料來源",
          content: "行政院環境部環境管理署 (環保稽查處分管制系統) - 客服專線：(02) 2361-1999#431",
        },

        {
          title: "資料說明",
          description_list: [
            "本頁面提供查詢之「裁處資訊」係由本部環境管理署「<a href='https://eems.moenv.gov.tw/' target='_blank' title='另開新視窗，至「環保稽查處分管制系統」'>環保稽查處分管制系統</a>」彙整各級環保機關針對事業違反環保法令所執行之裁處資料。",
            "倘對裁處資訊內容有疑義或需進一步瞭解其情形者，可洽詢開立該裁處案件之執行機關。",
            "裁處案件向本部提起訴願者，倘欲瞭解本部訴願會之決定及相關資料，請連結至本部「<a href='https://www.moenv.gov.tw/information-service/appeal/appeals-and-rulings/environmental-appeal/1185.html' target='_blank' title='另開新視窗，至「環保訴願專頁」'>環保訴願專頁</a>」查詢。",
            "本系統公開之資料，不構成任何政府申述、保證或暗示其同意、認可、推薦或批准意思表示。",
            "本部對於本系統公開之資料內容正確性及完整性，不負擔保之責。使用者如因使用本系統之資料而受損害或損失，或因此導致使用者或第三人遭受損害或損失而遭求償者，本部不負任何賠償或補償之責。",
          ],
        },
      ],
    },
    GreenHouse: {
      id: "GreenHouse",
      title: "溫室氣體",
      unit: false,
      category: [
        { name: "Year", title: "申報年度" },
        { name: "CO2", title: "CO2" },
        { name: "CH4", title: "CH4" },
        { name: "N2O", title: "N2O" },
        { name: "HFCS", title: "HFCS " },
        { name: "PFCS", title: "PFCS " },
        { name: "SF6", title: "SF6 " },
        { name: "NF3", title: "NF3 " },
        { name: "IndirectEmi", title: "間接排放量 " },
        { name: "TotalEmi", title: "總量 " },
        { name: "IsVoluntary", title: "自願揭露或法規規定" },
        { name: "IsCheck", title: "是否經查證" },
      ],
      noResult: {
        status: false,
      },
      other_data: [
        {
          title: "資料來源",
          content: "氣候變遷署 (事業溫室氣體排放量資訊平台)",
        },

        {
          title: "更新頻率",
          content: "一年",
        },
        {
          title: "資料說明",
          content: `排放量單位為公噸二氧化碳當量（公噸${co2e}）。溫室氣體排放資料係由本部氣候變遷署建置之「事業溫室氣體排放量資訊平台」匯入資料，其內容為事業依「溫室氣體排放量盤查登錄及查驗管理辦法」規定盤查及查驗溫室氣體排放量。「事業溫室氣體排放量資訊平台」系統客服專線：02-27753919 系統問題：分機326、242，倘對溫室氣體排放資料內容有疑義，可洽詢本部氣候變遷署（電話：02-2322-2050分機66221，66222，或可利用本系統「<a href='https://epamail.moenv.gov.tw/front/mailboxhome' title='另開新視窗，至「首長信箱」' target='_blank'>意見信箱</a>」與本部確認）。`,
        },
      ],
    },
    // Incin:{
    //     id: "Incin",
    //     title: "飛灰底渣檢測資料",
    //     unit:false,
    // }
  },
  detect_data: [
    {
      id: "bottom_detect",
      title: "底渣原始檢測資料",
      name: "BottomAsh",
      year_name: "REPORTDATE",
      category: [
        { name: "REPORTDATE", title: "日期" },
        { name: "PB", title: "鉛" },
        { name: "CD", title: "鎘" },
        { name: "HG", title: "汞" },
        { name: "CR", title: "鉻" },
        { name: "SN", title: "砷" },
        { name: "HEXCR", title: "六價鉻" },
        { name: "DIOXIN", title: "戴奧辛" },
        { name: "CU", title: "銅" },
        { name: "SE", title: "硒" },
      ],
    },
    {
      id: "ash_detect",
      title: "飛灰穩定化檢測資料",
      name: "FlyAsh",
      year_name: "REPORTDATE",
      category: [
        { name: "REPORTDATE", title: "日期" },
        { name: "PB", title: "鉛" },
        { name: "CD", title: "鎘" },
        { name: "HG", title: "汞" },
        { name: "CR", title: "鉻" },
        { name: "SN", title: "砷" },
        { name: "HEXCR", title: "六價鉻" },
        { name: "COMPRESSIVESTRENGTH", title: "抗壓強度" },
        { name: "DIOXIN", title: "戴奧辛" },
        { name: "CU", title: "銅" },
        { name: "SE", title: "硒" },
      ],
    },
    {
      id: "air_detect",
      title: "空污檢測資料",
      name: "Air",
      year_name: "APPLYDATE",
      category: [
        {
          category: [
            { name: "APPLYDATE", title: "核准日期" },
            { name: "NOX", title: "氮氧化物" },
            { name: "SOX", title: "硫氧化物" },
            { name: "COX", title: "碳氧化物" },
            { name: "HCL", title: "氯化氫" },
            { name: "DUST", title: "粒狀污染物" },
            { name: "OPACITY", title: "不透光率" },
            { name: "AIRUNUSUALOUTPUT", title: "有無異常排放" },
          ],
        },
        {
          category: [
            {
              name: "AIRDOSH",
              title: "戴奧辛檢測值",
            },
            {
              name: "AIRDOSH-TESTT",
              title: "檢測次數",
            },
          ],
        },
      ],
    },
    {
      id: "annual_service",
      title: "焚化廠營運年報",
      name: "YearlyReport",
      year_name: "APPLYYEAR",
    },
    {
      id: "montly_service",
      title: "焚化廠營運月報",
      name: "MonthlyReport",
      year_name: "APPLYDATE",
    },
  ],
};
let shared = {
  category: [
    {
      category: [
        { name: "APPLYYEAR", title: "核准年度" },
        { name: "GENWASTE", title: "一般廢棄物" },
        { name: "BIZGENWASTE", title: "一般事業廢棄物" },
        { name: "ICNRTPROQT", title: "焚化處理量" },
        { name: "BTMDUSTQT", title: "底渣量" },
      ],
    },
    {
      category: [
        { name: "FLYASHSOLDQT", title: "飛灰固化物量" },
        { name: "EQEFFGASACQT", title: "廢氣處理設備活性碳使用量" },
        { name: "ACTELEQT", title: "實際發電量" },
        { name: "ACTSEQT", title: "實際售電量" },
        { name: "ACTSEP", title: "實際售電率" },
      ],
    },
    {
      category: [
        { name: "SEINCOME", title: "售電收入" },
        { name: "OPRTHOUR", title: "操作時數" },
        { name: "NOOPRTHOUR", title: "停爐時數" },
        { name: "DSNPRCQT", title: "設計處理量" },
        { name: "DUSTLANDFILLQT", title: "灰渣送至掩埋場掩埋量" },
      ],
    },
  ],
};
